var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 7.5V5.83333C6.66663 3.99238 8.15901 2.5 9.99996 2.5C11.8409 2.5 13.3333 3.99238 13.3333 5.83333V7.5M6.83329 17.5H13.1666C14.1 17.5 14.5668 17.5 14.9233 17.3183C15.2369 17.1586 15.4918 16.9036 15.6516 16.59C15.8333 16.2335 15.8333 15.7668 15.8333 14.8333V10.1667C15.8333 9.23325 15.8333 8.76654 15.6516 8.41002C15.4918 8.09641 15.2369 7.84144 14.9233 7.68166C14.5668 7.5 14.1 7.5 13.1666 7.5H6.83329C5.89987 7.5 5.43316 7.5 5.07664 7.68166C4.76304 7.84144 4.50807 8.09641 4.34828 8.41002C4.16663 8.76654 4.16663 9.23325 4.16663 10.1667V14.8333C4.16663 15.7668 4.16663 16.2335 4.34828 16.59C4.50807 16.9036 4.76304 17.1586 5.07664 17.3183C5.43316 17.5 5.89987 17.5 6.83329 17.5Z",
    stroke: "#9599A1",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordLogin);
export default __webpack_public_path__ + "static/media/password-login.9339745288e76e63bd70fc3ea5393773.svg";
export { ForwardRef as ReactComponent };